"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_addons_css_transition_group_1 = __importDefault(require("react-addons-css-transition-group"));
var mobx_react_1 = require("mobx-react");
var classnames_1 = __importDefault(require("classnames"));
var mobx_1 = require("mobx");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var kaleidoscope_3 = require("@qwilr/kaleidoscope");
var CommentTypes_1 = require("../CommentTypes");
var CommentServiceTypes_1 = require("../CommentServiceTypes");
var AddCommentInput_1 = __importDefault(require("./AddCommentInput"));
var MentionUtilities_1 = require("../MentionUtilities");
var Types_1 = require("@CommonFrontendBackend/Permissions/Types");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var getAddErrorTooltipContent = function (outcome) {
    var _a;
    if (outcome === undefined || outcome === CommentServiceTypes_1.CommentSaveOutcome.None || outcome === CommentServiceTypes_1.CommentSaveOutcome.Success) {
        outcome = CommentServiceTypes_1.CommentSaveOutcome.UnknownFailure;
    }
    return (_a = {},
        _a[CommentServiceTypes_1.CommentSaveOutcome.CommentDeleted] = "This comment has been recently deleted. Refresh the page and try again.",
        _a[CommentServiceTypes_1.CommentSaveOutcome.ThreadDeleted] = "This thread has been recently deleted. Refresh the page and try again.",
        _a[CommentServiceTypes_1.CommentSaveOutcome.NetworkError] = "Connection issue. Try again?",
        _a[CommentServiceTypes_1.CommentSaveOutcome.LoggedOut] = "You've been logged out. Refresh the page to try again.",
        _a[CommentServiceTypes_1.CommentSaveOutcome.UnknownFailure] = "Send issue. Please try again or refresh the page.",
        _a)[outcome];
};
var shouldRenderTooltip = function (outcome) {
    return ![CommentServiceTypes_1.CommentSaveOutcome.Success, CommentServiceTypes_1.CommentSaveOutcome.None].includes(outcome);
};
var AddComment = (function (_super) {
    __extends(AddComment, _super);
    function AddComment(props) {
        var _this = _super.call(this, props) || this;
        _this.messageWithMentions = "";
        _this.isFocused = false;
        _this.sendCommentOutcome = CommentServiceTypes_1.CommentSaveOutcome.None;
        _this.commentIsSaving = false;
        _this.addingInviteMentions = false;
        _this.hasTouchedInput = false;
        _this.mentionOrigins = [];
        _this.lastMentionWasViaClick = false;
        _this.renderInputs = function () {
            var _a = _this.props, placeholderMessage = _a.placeholderMessage, onInviteUser = _a.onInviteUser;
            if (_this.pagePermissions === undefined) {
                return null;
            }
            return (react_1.default.createElement("div", { className: "add-comment__input-grouping" },
                react_1.default.createElement("div", { className: "add-comment__input-container" },
                    react_1.default.createElement(AddCommentInput_1.default, { onAddMentionComplete: _this.onAddMentionComplete, onBlur: _this.markUnfocused, onFocus: _this.markFocused, value: _this.message, placeholder: placeholderMessage, onChange: _this.updateMessage, inputRef: _this.inputRef, onKeyDown: _this.onKeyPress, pagePermissionsStore: _this.pagePermissions, onInviteUser: onInviteUser })),
                _this.renderButtons()));
        };
        _this.renderButtons = function () {
            var showMentionButton = _this.isFocused || !!_this.message;
            var showEmojiButton = (_this.isFocused || !!_this.message) && false;
            var showLoomButton = (_this.isFocused || !!_this.message) && false;
            var actionButtonTransitionDuration = 200;
            var actionButtonEnterDelay = 50;
            var submissionButtonTransitionDuration = 300;
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: "add-comment__buttons center-aligned" },
                    react_1.default.createElement(react_addons_css_transition_group_1.default, { component: react_1.default.Fragment, transitionName: "add-comment__submission-buttons__transitions", transitionEnterTimeout: submissionButtonTransitionDuration, transitionLeaveTimeout: submissionButtonTransitionDuration }, _this.shouldAllowSubmission && _this.renderSubmissionButtons())),
                react_1.default.createElement("div", { className: (0, classnames_1.default)("add-comment__input-buttons", "center-aligned") },
                    react_1.default.createElement(react_addons_css_transition_group_1.default, { component: react_1.default.Fragment, transitionName: "add-comment__input-button__slide-in", transitionEnterTimeout: actionButtonTransitionDuration + 2 * actionButtonEnterDelay, transitionLeaveTimeout: actionButtonTransitionDuration }, showMentionButton && (react_1.default.createElement(kaleidoscope_3.IconButton, { icon: react_1.default.createElement(icons_1.Mention, null), size: kaleidoscope_3.ButtonSize.Small, onClick: _this.addAtMention, tooltip: {
                            content: "Mention someone",
                            position: kaleidoscope_2.TooltipPosition.Top,
                        } }))),
                    react_1.default.createElement(react_addons_css_transition_group_1.default, { component: react_1.default.Fragment, transitionName: "add-comment__input-button__slide-in", transitionEnterTimeout: actionButtonTransitionDuration + actionButtonEnterDelay, transitionLeaveTimeout: actionButtonTransitionDuration }, showEmojiButton && (react_1.default.createElement(kaleidoscope_3.IconButton, { icon: react_1.default.createElement(icons_1.Emoji, null), size: kaleidoscope_3.ButtonSize.Small, tooltip: {
                            content: "Add emoji",
                            position: kaleidoscope_2.TooltipPosition.Top,
                        } }))),
                    react_1.default.createElement(react_addons_css_transition_group_1.default, { component: react_1.default.Fragment, transitionName: "add-comment__input-button__slide-in", transitionEnterTimeout: actionButtonTransitionDuration, transitionLeaveTimeout: actionButtonTransitionDuration }, showLoomButton && (react_1.default.createElement(kaleidoscope_3.IconButton, { icon: react_1.default.createElement(icons_1.Loom, null), size: kaleidoscope_3.ButtonSize.Small, tooltip: {
                            content: "Add a loom",
                            position: kaleidoscope_2.TooltipPosition.Top,
                        } }))))));
        };
        _this.renderSubmissionButtons = function () {
            var buttonState = _this.commentIsSaving ? kaleidoscope_3.ButtonState.Waiting : kaleidoscope_3.ButtonState.Idle;
            var renderTooltip = shouldRenderTooltip(_this.sendCommentOutcome);
            var tooltipContent = getAddErrorTooltipContent(_this.sendCommentOutcome);
            return (react_1.default.createElement("div", { key: "add-comment-submission-buttons", className: "add-comment__submission-buttons center-aligned" },
                react_1.default.createElement(kaleidoscope_1.ErrorTooltip, { renderTooltip: renderTooltip, content: tooltipContent, position: kaleidoscope_2.TooltipPosition.Top, size: kaleidoscope_2.TooltipSize.Large },
                    react_1.default.createElement(kaleidoscope_3.Button, { size: kaleidoscope_3.ButtonSize.Small, onClick: _this.sendComment, buttonState: buttonState }, "Post")),
                react_1.default.createElement(kaleidoscope_3.Button, { type: kaleidoscope_3.ButtonType.Secondary, size: kaleidoscope_3.ButtonSize.Small, onClick: _this.clearMessage }, "Cancel")));
        };
        _this.markFocused = function () {
            _this.isFocused = true;
        };
        _this.markUnfocused = function () {
            _this.isFocused = false;
        };
        _this.updateMessage = function (message, mentions, plainTextMessage) {
            if (message === void 0) { message = ""; }
            _this.message = message;
            _this.mentions = mentions;
            _this.hasTouchedInput = true;
            _this.messageWithMentions = plainTextMessage;
            _this.sendCommentOutcome = CommentServiceTypes_1.CommentSaveOutcome.None;
            _this.addingInviteMentions = mentions.reduce(function (prevValue, mention) {
                var needsInvite = _this.needsInvite(mention.id);
                return needsInvite || prevValue;
            }, false);
        };
        _this.clearMessage = function () {
            _this.clearMentionOrigins();
            _this.updateMessage(_this.props.startingMessage, [], "");
            _this.props.onCancel();
        };
        _this.clearMentionOrigins = function () {
            _this.mentionOrigins = [];
        };
        _this.onKeyPress = function (event) {
            _this.lastMentionWasViaClick = false;
            var commandKeyPressed = event.metaKey || event.ctrlKey;
            var triggerKeysFulfilled = commandKeyPressed && event.key === "Enter";
            if (!triggerKeysFulfilled) {
                return;
            }
            if (!_this.shouldAllowSubmission) {
                return;
            }
            _this.sendComment();
            event.preventDefault();
        };
        _this.getMentionOriginForTelemetry = function () {
            if (_this.mentionOrigins.length === 0) {
                return CommentTypes_1.MentionOrigin.None;
            }
            var firstMentionOrigin = _this.mentionOrigins[0];
            var isSameOrigin = _this.mentionOrigins.every(function (origin) { return origin === firstMentionOrigin; });
            return isSameOrigin ? firstMentionOrigin : CommentTypes_1.MentionOrigin.Both;
        };
        _this.sendComment = function () { return __awaiter(_this, void 0, Promise, function () {
            var messageToSend, mentionsToSend, _a, startingMessage, startingMentions, onSend, finishedMessage, _b, packedMessage, mentions, commentMessage, sendOutcome;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this.props, startingMessage = _a.startingMessage, startingMentions = _a.startingMentions, onSend = _a.onSend;
                        this.commentIsSaving = true;
                        this.sendCommentOutcome = CommentServiceTypes_1.CommentSaveOutcome.None;
                        if (this.hasTouchedInput) {
                            finishedMessage = this.message;
                            _b = (0, MentionUtilities_1.packMessageAndMentions)(finishedMessage, this.mentions), packedMessage = _b.message, mentions = _b.mentions;
                            messageToSend = packedMessage;
                            mentionsToSend = mentions;
                        }
                        else {
                            messageToSend = startingMessage || "";
                            mentionsToSend = startingMentions || [];
                        }
                        commentMessage = {
                            message: messageToSend,
                            mentions: mentionsToSend,
                            contentWithMentions: this.messageWithMentions,
                            mentionOrigin: this.getMentionOriginForTelemetry(),
                        };
                        return [4, onSend(commentMessage, function () { return __awaiter(_this, void 0, void 0, function () {
                                var needsAccess;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            needsAccess = mentionsToSend.map(function (mention) { return mention.userId; }).filter(this.needsInvite);
                                            if (!(needsAccess.length > 0)) return [3, 2];
                                            return [4, this.giveEditAccess(needsAccess)];
                                        case 1:
                                            _a.sent();
                                            _a.label = 2;
                                        case 2:
                                            this.clearMessage();
                                            this.sendCommentOutcome = CommentServiceTypes_1.CommentSaveOutcome.None;
                                            return [2];
                                    }
                                });
                            }); })];
                    case 1:
                        sendOutcome = _c.sent();
                        this.commentIsSaving = false;
                        this.sendCommentOutcome = sendOutcome;
                        return [2];
                }
            });
        }); };
        _this.addAtMention = function () {
            _this.message += "@";
            if (_this.inputRef.current) {
                _this.inputRef.current.focus();
            }
            _this.lastMentionWasViaClick = true;
        };
        _this.onAddMentionComplete = function () {
            var mentionOrigin = _this.lastMentionWasViaClick ? CommentTypes_1.MentionOrigin.Icon : CommentTypes_1.MentionOrigin.Keyboard;
            _this.mentionOrigins.push(mentionOrigin);
            _this.lastMentionWasViaClick = false;
        };
        _this.needsInvite = function (userId) {
            if (!_this.pagePermissions) {
                throw new Error("Checking invites before permissions have loaded");
            }
            if (!userId) {
                return false;
            }
            var permission = _this.pagePermissions.getUserPermission(userId);
            return permission === Types_1.Action.View || permission === Types_1.Action.None;
        };
        _this.giveEditAccess = function (userIds) { return __awaiter(_this, void 0, Promise, function () {
            return __generator(this, function (_a) {
                if (!this.pagePermissions) {
                    throw new Error("Attempting to give access before permissions have loaded");
                }
                return [2, this.pagePermissions.updateUserPermissions(userIds, Types_1.Action.Edit)];
            });
        }); };
        _this.inputRef = react_1.default.createRef();
        _this.message = props.startingMessage || "";
        _this.mentions = [];
        if (props.startingMentions) {
            _this.message = (0, MentionUtilities_1.mergeMessageForEdit)(_this.message, props.startingMentions, props.usersInAccount);
        }
        if (_this.props.autoFocus) {
            _this.markFocused();
        }
        return _this;
    }
    AddComment.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.pagePermissions = this.props.permissionsStore.getPagePermissions(this.props.projectId);
                        return [4, this.pagePermissions.fetchData()];
                    case 1:
                        _a.sent();
                        if (this.props.autoFocus && this.inputRef.current) {
                            this.inputRef.current.focus();
                        }
                        return [2];
                }
            });
        });
    };
    AddComment.prototype.render = function () {
        var _a = this.props, firstName = _a.firstName, lastName = _a.lastName;
        var userIconClasses = (0, classnames_1.default)("add-comment__user-icon", { "add-comment__user-icon--faded": !this.isFocused });
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: "add-comment" },
                react_1.default.createElement("div", { className: userIconClasses },
                    react_1.default.createElement(kaleidoscope_3.Avatar, { firstName: firstName, lastName: lastName })),
                this.renderInputs()),
            this.addingInviteMentions && (react_1.default.createElement("div", { className: "add-comment__mention-message" }, "All users who have been mentioned will be given edit access to this page"))));
    };
    Object.defineProperty(AddComment.prototype, "shouldAllowSubmission", {
        get: function () {
            return !!this.message;
        },
        enumerable: false,
        configurable: true
    });
    var _a, _b;
    AddComment.defaultProps = {
        startingMessage: "",
        autoFocus: false,
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", String)
    ], AddComment.prototype, "message", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", String)
    ], AddComment.prototype, "messageWithMentions", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Array)
    ], AddComment.prototype, "mentions", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], AddComment.prototype, "isFocused", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", typeof (_a = typeof CommentServiceTypes_1.CommentSaveOutcome !== "undefined" && CommentServiceTypes_1.CommentSaveOutcome) === "function" ? _a : Object)
    ], AddComment.prototype, "sendCommentOutcome", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], AddComment.prototype, "commentIsSaving", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], AddComment.prototype, "addingInviteMentions", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], AddComment.prototype, "pagePermissions", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Array)
    ], AddComment.prototype, "mentionOrigins", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Boolean)
    ], AddComment.prototype, "lastMentionWasViaClick", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], AddComment.prototype, "shouldAllowSubmission", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AddComment.prototype, "markFocused", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AddComment.prototype, "markUnfocused", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AddComment.prototype, "updateMessage", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AddComment.prototype, "clearMessage", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AddComment.prototype, "clearMentionOrigins", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AddComment.prototype, "onKeyPress", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AddComment.prototype, "sendComment", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AddComment.prototype, "addAtMention", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Object)
    ], AddComment.prototype, "onAddMentionComplete", void 0);
    AddComment = __decorate([
        mobx_react_1.observer,
        __metadata("design:paramtypes", [Object])
    ], AddComment);
    return AddComment;
}(react_1.default.Component));
exports.default = AddComment;
